module.exports = __webpack_public_path__ + "media/images/emoticons/yacht-bc43df04896a8aa113f25e2e9b12c9dc.gif";